var generateStyle = function generateStyle(componentTheme) {
  return {
    labelRemoved: {
      textDecoration: 'line-through'
    }
  };
};
export default generateStyle;